import { Component, NgZone, OnInit } from '@angular/core';
import { AppFacade } from './store/facade';
import { AngularFireAuth } from '@angular/fire/auth';
import { SpinnerService } from './services/spinner.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title;

  appSemtID$ = this.facade.getSemtID$
  spinner: Subject<boolean> = this.spinnerService.isLoading;

  constructor(private facade: AppFacade, private fireAuth: AngularFireAuth, private firestore: AngularFirestore,
    private spinnerService: SpinnerService, private zone: NgZone, private router: Router) {
  }

  ngOnInit() {

    this.fireAuth.onAuthStateChanged(user => {
      if(user) {
        this.zone.run(() => this.facade.loadCurrentUser());
      }
    });

    setTimeout( async () => {

      this.facade.getCredential$.subscribe(data => {
        if(!data) {
          this.router.navigate(['/login']);
        }
      });
    }, 10000);
  }
}
